import type { AuthModuleData } from '../types';
import type { AbstractModel } from '@patsnap/tahiti-core/common/model';

export const AuthModel = Symbol('AuthModel');

export interface AuthModel extends AbstractModel<AuthModuleData> {
  updateModuleData(getUpdateModuleValue: (value: AuthModuleData) => AuthModuleData): void;
}
